import type { ReactElement, SVGProps } from "react";

export function PlugConnectionIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 7v4a3 3 0 0 0 6 0V7" />
      <line x1="9" y1="3" x2="9" y2="7" />
      <line x1="15" y1="3" x2="15" y2="7" />
      <line x1="12" y1="14" x2="12" y2="21" />
    </svg>
  );
}
